import { Flex, Paper, Stack, Text } from "@mantine/core";
import classes from "./index.module.css";
import { TInsuranceParty } from "@/hooks/api/useGetInsuranceById";
import { REPLAY_BLOCK_CLASS } from "../../utils/statsig";

function determinePartyType(party: TInsuranceParty) {
  switch (party.relType) {
    case "is_insured_by":
      return "Försäkringsgivare";

    case "is_insured":
      return "Försäkrad";

    case "is_owner":
      return "Försäkringstagare";
    default:
      return "Okänd relation";
  }
}

function formatIdentity(identity: string) {
  if (identity.length === 12) {
    // Format as org number: 123456-7890
    return `${identity.slice(0, 8)}-${identity.slice(8)}`;
  } else if (identity.length === 10) {
    // Format as personal number: 123456-7890
    return `${identity.slice(0, 6)}-${identity.slice(6)}`;
  } else {
    return identity; // Return as is if it doesn't match known formats
  }
}

const InsurancesPartyList = ({ party }: { party: TInsuranceParty }) => {
  let header = determinePartyType(party);

  let showItem = party.firstName || party.lastName || party.legalName;

  return (
    <>
      {showItem && (
        <Paper radius={"lg"} className={classes.insuranceListItemPaper}>
          <Flex className={classes.insuranceListItemContainer}>
            <Stack className={classes.insuranceListItemStack}>
              <Text>
                <strong>{header}</strong>
              </Text>
              <Text fw={500} className={REPLAY_BLOCK_CLASS}>
                {party.legalName
                  ? party.legalName
                  : `${party.firstName} ${party.lastName}`}
              </Text>
              <Text color="dimmed" className={REPLAY_BLOCK_CLASS}>
                {formatIdentity(party.identity)}
              </Text>
            </Stack>
          </Flex>
        </Paper>
      )}
    </>
  );
};

export default InsurancesPartyList;
